// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"9f0ff194","328":"d92b237b","396":"b9477529"}[chunkId] + ".chunk.js";
};